import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";


const ProductCard = ({ product, handleAddToCart }) => {
  const {name,cost,rating,image,_id}=product;

  return (
    <Card className="card" >

        <CardMedia
          component="img"
          height="140"
          image={image}
          alt={name}
          sx={{height : "320px"}}
          className="productImg"
    
        />
        <CardContent>
          <Typography gutterBottom variant="h6">
          {name}
          </Typography>
          <Typography gutterBottom  sx={{ fontWeight: 'bold' }}>
            ${cost}
          </Typography>
          <Rating name="read-only" value={rating} readOnly />
          <Button variant="contained" sx={{width : "100%"}} value={_id} onClick={handleAddToCart}><AddShoppingCartOutlined /> &nbsp; ADD TO CART</Button>
        </CardContent>
    </Card>
  );
};

export default ProductCard;
